module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"closeButton":{"label":"Video schließen"},"helpWindowTitle":"Brauchst du Hilfe?","onboardingVideoButton":{"label":"Onboarding-Video"},"reportButton":{"label":"Feedback und Fehlermeldungen"},"faqButton":{"label":"FAQ"}}}')
  delete Component.options._Ctor
}
